import { queryOptions, useQuery } from '@tanstack/react-query';

import { productKeys } from '@/features/products';

import { storeCatalogApi } from '../api/store-catalog-api';

/** The window the product page shows: the last 30 store days, today included. */
export const PRODUCT_ENGAGEMENT_DAYS = 30;

/**
 * One master product's engagement per store the member can access. Organisation-level, so the
 * key hangs off the product's own detail key and refetches with it.
 */
export function productEngagementQueryOptions(productId: string, days = PRODUCT_ENGAGEMENT_DAYS) {
  return queryOptions({
    queryKey: [...productKeys.detail(productId), 'engagement', days] as const,
    queryFn: () => storeCatalogApi.productEngagement(productId, days),
  });
}

export function useProductEngagement(productId: string, days = PRODUCT_ENGAGEMENT_DAYS) {
  return useQuery(productEngagementQueryOptions(productId, days));
}
